import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Card, Tab, Tabs } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

// custom hooks
import useISPowner from "../../hooks/useISPOwner";

// internal imports
import Loader from "../../components/common/Loader";
import { purchaseSms } from "../../features/apiCalls";
import ComponentCustomModal from "../../components/common/customModal/ComponentCustomModal";
import {
  getParchaseHistory,
  purchaseSMS,
} from "../../features/resellerParchaseSmsApi";

const SMSPurchase = ({ show, setShow }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // get user & current user data form useISPOwner hook
  const { role, bpSettings, ispOwnerData, userData } = useISPowner();

  // get reseller sms purchase history
  const data = useSelector((state) => state?.smsHistory?.smsParchase);

  // get accept status
  const invoiceStatus = data.filter((item) => item.status === "pending");

  //user Data
  const user = role === "manager" ? ispOwnerData : userData;

  // loading state
  const [isLoading, setIsloading] = useState(false);
  const [activeTab, setActiveTab] = useState("text");
  const [amount, setAmount] = useState(activeTab === "voice" ? 1000 : 120);
  const [count, setCount] = useState(Number(amount) / user.smsRate);
  const [buyStatus, setBuyStatus] = useState("netFee");
  const [messageType, setMessageType] = useState(
    "nonMasking" || "masking" || "fixedNumber",
  );

  // get api clled function
  useEffect(() => {
    role === "reseller" &&
      getParchaseHistory(userData.id, dispatch, setIsloading);
  }, [role]);

  const handleActiveTab = (eventKey) => {
    setActiveTab(eventKey);
    if (eventKey === "voice") {
      setAmount(140);
      setCount(Math.ceil(140 / user?.voiceMessageRate));
    } else {
      setAmount(120);
      setCount(Math.ceil(120 / user.smsRate));
    }
  };

  //SMS count function
  const changeHandler = (numOfSms) => {
    if (messageType === "nonMasking") {
      setAmount(
        Math.ceil(
          activeTab === "voice"
            ? user?.voiceMessageRate * numOfSms
            : user.smsRate * numOfSms,
        ),
      );
    } else if (messageType === "masking") {
      setAmount(Math.ceil(user.maskingSmsRate * numOfSms));
    } else if (messageType === "fixedNumber") {
      setAmount(Math.ceil(user.fixedNumberSmsRate * numOfSms));
    }

    // set purchase sms count
    setCount(numOfSms);
  };

  //Money count function
  const tkHandler = (money) => {
    money = Math.ceil(money);
    if (messageType === "nonMasking") {
      setCount(
        Math.ceil(
          activeTab === "voice"
            ? money / user?.voiceMessageRate
            : money / user.smsRate,
        ),
      );
    } else if (messageType === "masking") {
      setCount(Math.ceil(money / user.maskingSmsRate));
    } else if (messageType === "fixedNumber") {
      setCount(Math.ceil(money / user.fixedNumberSmsRate));
    }

    // set purchase sms amount
    setAmount(money);
  };

  //form submit handler
  const submitHandler = () => {
    if (count < 250) {
      toast.error(t("unsuccessSMSalertPurchageModal"));
    } else {
      if (
        ["ispOwner", "manager"].includes(role) ||
        (role === "reseller" && buyStatus === "netFee")
      ) {
        const sendData = {
          amount: Math.ceil(amount),
          numberOfSms: Number.parseInt(count),
          ispOwner: user.id,
          user: user.user,
          type: activeTab === "voice" ? "voiceMessagePurchase" : "smsPurchase",
          smsPurchaseType: messageType,
        };

        // id for role based
        if (role === "reseller") {
          delete sendData.ispOwner;
          sendData.reseller = userData.id;
        }

        // netfee sms purchase api call
        purchaseSms(sendData, setIsloading, dispatch, setShow, navigate);
      } else {
        if (invoiceStatus.length === 0) {
          const sendData = {
            smsAmount: Number.parseInt(count),
            smsParchaseType: messageType,
          };

          // andmin sms purchase api call
          purchaseSMS(sendData, setIsloading, dispatch, setShow);
        } else {
          toast.error(t("statusCannotBePending"));
        }
      }
    }
  };

  // set sms purchase amount and count on message type
  useEffect(() => {
    // message purchase
    if (messageType === "nonMasking") {
      setAmount(
        Math.ceil(
          activeTab == "voice"
            ? user?.voiceMessageRate * count
            : user.smsRate * count,
        ),
      );
    } else if (messageType === "masking") {
      setAmount(Math.ceil(user.maskingSmsRate * count));
    } else if (messageType === "fixedNumber") {
      setAmount(Math.ceil(user.fixedNumberSmsRate * count));
    }
  }, [activeTab, messageType]);

  return (
    <>
      <ComponentCustomModal
        show={show}
        setShow={setShow}
        header={t("smsPurchageBoard")}
        centered={true}
        size="md"
        footer={
          <div className="displayGrid1 float-end">
            <button
              className="btn btn-secondary"
              onClick={() => setShow(false)}
            >
              {t("cancel")}
            </button>
            <button className="btn btn-success" onClick={submitHandler}>
              {isLoading ? <Loader /> : t("buySMS")}
            </button>
          </div>
        }
      >
        <div className="container">
          <Tabs
            defaultActiveKey="text"
            id="fill-tab-example"
            className="mb-3"
            fill
            onSelect={(eventKey) => handleActiveTab(eventKey)}
          >
            <Tab eventKey="text" title={t("text")}>
              <div className="displayGrid3 clintTitle p-2 mb-3">
                <div>
                  <label className="form-control-label">
                    {t("nonMasking")}
                  </label>
                  <span
                    className={`text-${
                      user.smsBalance >= 0 ? "success" : "danger"
                    } fw-bold`}
                  >
                    {user.smsBalance}
                  </span>
                </div>
                <div>
                  <label className="form-control-label">{t("masking")}</label>
                  <span
                    className={`text-${
                      user.maskingSmsBalance >= 0 ? "success" : "danger"
                    } fw-bold`}
                  >
                    {user.maskingSmsBalance}
                  </span>
                </div>
                <div>
                  <label className="form-control-label">
                    {t("fixedNumber")}
                  </label>
                  <span
                    className={`text-${
                      user.fixedNumberSmsBalance >= 0 ? "success" : "danger"
                    } fw-bold`}
                  >
                    {user.fixedNumberSmsBalance}
                  </span>
                </div>
              </div>
            </Tab>
            {bpSettings?.voiceMessage && (
              <Tab eventKey="voice" title={t("voice")}>
                <div className="displayGrid3 clintTitle p-2 mb-3">
                  <div>
                    <label className="form-control-label">
                      {t("nonMasking")}
                    </label>
                    <span
                      className={`text-${
                        user?.voiceMessageBalance >= 0 ? "success" : "danger"
                      } fw-bold`}
                    >
                      {user?.voiceMessageBalance}
                    </span>
                  </div>
                </div>
              </Tab>
            )}
          </Tabs>

          <Card className="bg-light">
            <Card.Body>
              <Card.Text>
                <div className="monthlyBill text-center">
                  <span className="fw-bold"> {t("purchagePrice")} </span>
                  <span className="price">
                    <strong>৳{Math.ceil(amount)}</strong>
                  </span>
                </div>

                <form className="displayGrid">
                  <div>
                    <label class="form-control-label text-secondary">
                      {t("smsType")}&nbsp;
                      <span className="text-danger">*</span>
                    </label>

                    <select
                      className="form-select mw-100 mt-0 bg-white"
                      onChange={(e) => setMessageType(e.target.value)}
                      disabled={activeTab === "voice" ? true : false}
                    >
                      <option selected value="nonMasking">
                        {t("nonMasking")}
                      </option>
                      <option value="masking">{t("masking")}</option>
                      <option value="fixedNumber">{t("fixedNumber")}</option>
                    </select>
                  </div>

                  <div>
                    <label class="form-control-label text-secondary">
                      {t("SMS") + " " + t("count")}&nbsp;
                      <span className="text-danger">*</span>
                    </label>

                    <input
                      onChange={(e) => changeHandler(e.target.value)}
                      className="form-control bg-white"
                      type="number"
                      value={count}
                      min={250}
                    />
                  </div>

                  <div>
                    <label className="form-control-label text-secondary">
                      {t("amount")}&nbsp;
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      onChange={(e) => tkHandler(e.target.value)}
                      className="form-control bg-white"
                      type="number"
                      value={amount && amount}
                      min={100}
                    />
                  </div>

                  {role === "reseller" && (
                    <div>
                      <label className="form-control-label text-secondary">
                        {t("selectPlace")}&nbsp;
                        <span className="text-danger">*</span>
                      </label>

                      <select
                        className="form-select mw-100 mt-0 bg-white"
                        onChange={(e) => setBuyStatus(e.target.value)}
                      >
                        <option value="netFee" selected>
                          NetFee
                        </option>
                        <option value="ispOwner">Isp Owner</option>
                      </select>
                    </div>
                  )}
                </form>
              </Card.Text>
            </Card.Body>
          </Card>
        </div>
      </ComponentCustomModal>
    </>
  );
};

export default SMSPurchase;
